import ContextProcessor from '../../context/context-processor';
import { createC11nEnv } from '../c11n-env';
import type { Meta, Options } from '../types';

class RepeatDataIterator {
  private readonly meta: Meta;
  private readonly datasource: string;
  private readonly options: Options;
  private index: number;
  private readonly datasourceObj: any;

  constructor(meta: Meta, datasource: string, options: Options) {
    this.meta = meta;
    this.datasource = datasource;
    this.index = 0;
    this.options = options;
    this.datasourceObj = ContextProcessor.getPropertyValue(datasource, options.pageReference, options.context);
  }

  hasNext() {
    return this.index < this.datasourceObj.length;
  }

  next() {
    if (!this.hasNext()) {
      throw new Error('No Children');
    }
    const context = ContextProcessor.getContextPath(this.datasource, this.index);
    this.index += 1;
    return createC11nEnv({
      meta: this.meta,
      options: {
        ...this.options,
        pageReference: context
      }
    });
  }

  resetIndex() {
    this.index = 0;
  }
}

export default RepeatDataIterator;
